import { render, staticRenderFns } from "./cardAssmat.vue?vue&type=template&id=05afd52e"
import script from "./cardAssmat.vue?vue&type=script&lang=js"
export * from "./cardAssmat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports